// Bubble-tray layout. Positions are stored as page fractions so they are
// zoom- and resolution-independent and identical between the on-screen canvas
// and the exported PDF page. Spacing adapts to the configured bubble size.

export function colsFor(n) {
    if (n <= 1) return 1;
    return Math.min(12, Math.max(1, Math.ceil(Math.sqrt(n * 1.3))));
}

export function computeUnits(rows, rowColors) {
    const units = [];
    rows.forEach((row) => {
        // Only create bubbles once the dimensions (width & height) are entered.
        const w = Number(row.width);
        const h = Number(row.height);
        if (!w || !h || w <= 0 || h <= 0) return;
        const n = Math.max(1, parseInt(row.qty, 10) || 1);
        const hex = rowColors[row.id]?.hex || "#2563eb";
        for (let i = 0; i < n; i++) {
            units.push({ unitId: `${row.id}:${i}`, row_id: row.id, label: row.blindPos || row.position || "P", color: hex });
        }
    });
    return units;
}

function metrics(W, scale) {
    const D = W * 0.03 * (scale || 1);
    return { D, R: D / 2, STEP: D + W * 0.012, PAD: W * 0.012, HEADER: W * 0.028 };
}

export function layoutUnits(units, tray, unitOffsets, W, H, cols, page) {
    const { R, STEP, PAD, HEADER } = metrics(W, tray.bubble_scale);
    const offsets = unitOffsets || {};
    const unplaced = units.filter((u) => !offsets[u.unitId]).length;
    const COLS = cols || colsFor(unplaced);
    const result = [];
    let gi = 0;
    for (const u of units) {
        const off = offsets[u.unitId];
        if (off) {
            if ((off.page || 1) === page) result.push({ ...u, cx: off.fx * W, cy: off.fy * H, r: R });
        } else {
            if (tray.page === page) {
                const col = gi % COLS;
                const rr = Math.floor(gi / COLS);
                result.push({ ...u, cx: tray.x * W + PAD + col * STEP + R, cy: tray.y * H + HEADER + rr * STEP + R, r: R });
            }
            gi += 1;
        }
    }
    return result;
}

export function trayPanelSize(unitCount, W, cols, scale = 1) {
    const { STEP, PAD, HEADER } = metrics(W, scale);
    const COLS = cols || colsFor(unitCount);
    const rowsCount = Math.max(1, Math.ceil(unitCount / COLS));
    return { width: PAD * 2 + COLS * STEP, height: HEADER + PAD + rowsCount * STEP, header: HEADER };
}
